import { render, staticRenderFns } from "./UserLoggedIn.vue?vue&type=template&id=06297230&scoped=true&"
import script from "./UserLoggedIn.vue?vue&type=script&lang=js&"
export * from "./UserLoggedIn.vue?vue&type=script&lang=js&"
import style0 from "./UserLoggedIn.vue?vue&type=style&index=0&id=06297230&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06297230",
  null
  
)

export default component.exports